import { Component, Input } from '@angular/core';

import * as debug from 'debug';

@Component({
  selector: 'count-down-timer',
  templateUrl: 'count-down-timer.html',
})
export class CountDownTimerComponent {
  log = debug('app:CountDownTimerComponent');

  //expected initial time format for input data : "2025-01-31T10:00:00.000Z"

  @Input() initialTime;
  @Input() additionalTextStart;
  @Input() additionalTextEnd;

  remainingTime!: number;
  timerInterval!: any;

  constructor() {}

  ngOnInit(): void {
    this.startTimer();
  }

  startTimer(): void {
    const targetTime = new Date(this.initialTime).getTime();

    this.timerInterval = setInterval(() => {
      const currentTime = new Date().getTime();
      this.remainingTime = Math.max(
        0,
        Math.floor((targetTime - currentTime) / 1000)
      );

      if (this.remainingTime === 0) {
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  padNumber(num: number): string {
    return (num < 10 ? '0' : '') + num;
  }

  getFormattedTime(): string {
    const days = Math.floor(this.remainingTime / 86400);
    const hours = Math.floor((this.remainingTime % 86400) / 3600);
    const minutes = Math.floor((this.remainingTime % 3600) / 60);
    const seconds = this.remainingTime % 60;

    if (days > 1) {
      return `${days} days`;
    }
  
    // If exactly 1 day is left, return "1 day left"
    if (days === 1) {
      return `1 day`;
    }

    if (hours > 0) {
      return `${this.padNumber(hours)}h ${this.padNumber(
        minutes
      )}m ${this.padNumber(seconds)}s`;
    }

    if (minutes > 0) {
      return `${this.padNumber(minutes)} : ${this.padNumber(seconds)}s`;
    }

    return `${this.padNumber(seconds)}s`;
  }

  ngOnDestroy(): void {
    clearInterval(this.timerInterval);
  }
}



// WEBPACK FOOTER //
// ./src/components/count-down-timer/count-down-timer.ts